export const usageMap = [
	{
		slug  : 'blog_media',
		title : 'Blog',
	},
	{
		slug  : 'retail_ecommerce',
		title : 'Online Store',
	},
	{
		slug  : 'small_business',
		title : 'Small Offline Business',
	},
	{
		slug  : 'corporation',
		title : 'Corporation',
	},
	{
		slug  : 'portfolio',
		title : 'Portfolio',
	},
	{
		slug  : 'other',
		title : 'Something else',
	},
]

export const goalMap = [
	{
		slug  : 'grow',
		title : 'Get more email subscribers',
	},
	{
		slug  : 'generate_leads',
		title : 'Increase website conversions',
	},
	{
		slug  : 'reduce_abandonment',
		title : 'Reduce cart abandonment',
	},
	{
		slug  : 'redirect_traffic',
		title : 'Redirect traffic to top pages',
	},
	{
		slug  : 'time_sensitive',
		title : 'Promote time-sensitive offers',
	},
	{
		slug  : 'social_media',
		title : 'Increase social media followers',
	},
]

export const featureMap = [
	{
		slug        : 'campaigns',
		title       : 'All Campaign Types',
		description : 'Lightbox popups, floating bars, fullscreen welcome mats, slide-ins and more!',
		free        : true,
	},
	{
		slug        : 'page-level-targeting',
		title       : 'Page Level Targeting',
		description : 'Use behavior personalization to display page-specific campaigns on your website.',
		free        : true,
	},
	{
		slug        : 'google-analytics',
		title       : 'Google Analytics for WordPress',
		description : 'Connect your site with Google Analytics to make data-driven decisions for your business.',
		plugin      : {
			title : 'Google Analytics Dashboard Plugin for WordPress by MonsterInsights',
			slug  : 'google-analytics-for-wordpress/googleanalytics.php',
		},
	},
	{
		slug        : 'social-proof',
		title       : 'Social Proof Notifications',
		description : 'Leverage the true power of social proof to increase site conversions by up to 15%!',
		plugin      : {
			title : 'TrustPulse',
			slug  : 'trustpulse-api/trustpulse.php',
		},
	},
	{
		slug        : 'seo',
		title       : 'All in One SEO',
		description : 'Powerful toolkit to improve your SEO rankings and uncover new growth opportunities.',
		plugin      : {
			title : 'All-in-One SEO Pack',
			slug  : 'all-in-one-seo-pack/all_in_one_seo_pack.php',
		},
	},
	{
		slug        : 'split-test',
		featureId   : 'ab-testing',
		title       : 'A/B Split Testing',
		description : 'Eliminate the guesswork by testing your different content in your campaigns.',
	},
	{
		slug        : 'exit-intent',
		title       : 'Exit-Intent® Targeting',
		description : 'Personalize your campaigns based on your visitor\'s behavior to maximize conversions.',
	},
	{
		slug        : 'yesno',
		featureId   : 'yesno-buttons',
		title       : 'Yes / No Multi-Step Campaigns ',
		description : 'Create multi-step campaigns to boost traffic and grow your email list.',
	},
	{
		slug        : 'coupon-wheel-campaigns',
		title       : 'Gamified Coupon Wheel',
		description : 'Create interactive spin-a-wheel games to instantly multiply sales and conversions.',
		usage       : 'retail_ecommerce',
	},
	{
		slug        : 'content-locker',
		title       : 'Content Locker',
		description : 'Grow your email list fast by locking your most in-demand content on your website.',
		usage       : 'blog_media',
	},
	{
		slug        : 'onsite-targeting',
		title       : 'OnSite Retargeting & Follow Up Campaigns',
		description : 'Reduce abandonment and boost sales by customizing promotions for returning visitors.',
	},
]

export const emailProviders = [
	{
		slug  : 'mailchimpv3',
		title : 'Mailchimp',
	},
	{
		slug  : 'constant-contact',
		title : 'Constant Contact',
	},
	{
		slug  : 'activecampaign',
		title : 'ActiveCampaign',
	},
	{
		slug  : 'aweber',
		title : 'AWeber',
	},
	{
		slug  : 'hubspot',
		title : 'HubSpot',
	},
	{
		slug  : 'klaviyo',
		title : 'Klaviyo',
	},
	{
		slug  : 'infusionsoft',
		title : 'Infusionsoft',
	},
	{
		slug  : 'drip',
		title : 'Drip',
	},
	{
		slug  : 'convertkit',
		title : 'ConvertKit',
	},
	{
		slug  : 'getresponse',
		title : 'GetResponse',
	},
	{
		slug  : 'pardot',
		title : 'Pardot',
	},
	{
		slug  : 'sendinblue-v2',
		title : 'SendinBlue',
	},
	{
		slug  : 'bronto',
		title : 'Bronto',
	},
	{
		slug  : 'campaign-monitor',
		title : 'Campaign Monitor',
	},
	{
		slug  : 'conversio',
		title : 'Conversio',
	},
	{
		slug  : 'customerio',
		title : 'Customer.io',
	},
	{
		slug  : 'eloqua',
		title : 'Eloqua',
	},
	{
		slug  : 'emailoctopus',
		title : 'EmailOctopus',
	},
	{
		slug  : 'emma',
		title : 'Emma',
	},
	{
		slug  : 'feedblitz',
		title : 'Feedblitz',
	},
	{
		slug  : 'icontact',
		title : 'iContact',
	},
	{
		slug  : 'ipost',
		title : 'iPost',
	},
	{
		slug  : 'jilt',
		title : 'Jilt',
	},
	{
		slug  : 'madmimi',
		title : 'Mad Mimi',
	},
	{
		slug  : 'mailerlite',
		title : 'MailerLite',
	},
	{
		slug  : 'mailpoet',
		title : 'MailPoet',
	},
	{
		slug  : 'marketo',
		title : 'Marketo',
	},
	{
		slug  : 'ontraport',
		title : 'Ontraport',
	},
	{
		slug  : 'sendloop',
		title : 'Sendloop',
	},
	{
		slug  : 'sendpulse',
		title : 'SendPulse',
	},
	{
		slug  : 'sharpspring',
		title : 'SharpSpring',
	},
	{
		slug  : 'other',
		title : 'Other',
	},
]
